import request from '@/utils/axios'
import { ContentTypeEnum } from '@/enums/axios'
import { useAccountStore } from '@/stores/modules/account'
import { router } from '@/router'

const jsonHeaderConfig = {
  headers: {
    'Content-Type': ContentTypeEnum.JSON
  }
}

const perfix = '/erp' // 服务地址

// 合同列表查询(本机构的)
export const getContractList = (data: any) =>
  request.post(perfix + '/retailContractManage/pageQuery', data, jsonHeaderConfig)

// 合同列表查询（共享的）
export const pageQueryByPartake = (data: any) =>
  request.post(perfix + '/retailContractManage/pageQueryByPartake', data, jsonHeaderConfig)

// 合同详情查询
export const getContractDetails = (data: any) =>
  request.post(perfix + '/retailContractManage/queryByContractId', data, jsonHeaderConfig)

// 模糊查询客户列表
export const getCustomerList = (data: any, options: Recordable) =>
  request.post(perfix + '/retailContractManage/selectOrderByUserAuth', data, options)

// 模糊化查询业务编号
export const getBusinessCodeList = (data: any) =>
  request.post(perfix + '/retailContractManage/businessCodeDownList', data, jsonHeaderConfig)

// 通过业务编号获取业务详情
export const getBusinessInfo = (data: any) =>
  request.post(perfix + '/retailContractManage/queryByBusinessCode', data, jsonHeaderConfig)

// 保存合同
export const saveContract = (data: any) =>
  request.post(perfix + '/retailContractManage/saveContract', data, jsonHeaderConfig)

// 更新合同
export const updateContract = (data: any) =>
  request.post(perfix + '/retailContractManage/updateContract', data, jsonHeaderConfig)

// 发送合同
export const sendContract = (data: any) => {
  // eslint-disable-next-line no-async-promise-executor
  return new Promise(async (resolve, reject) => {
    const accountStore = useAccountStore()
    const userInfo = accountStore.userInfo
    try {
      const res = await request.post(
        perfix + '/retailContractManage/sendContract',
        data,
        jsonHeaderConfig,
        { isReturnNativeResponse: true }
      )
      console.log(res)
      if (res.data.code === 200) {
        resolve(res.data)
      } else {
        if (res.data.subCode === 10001) {
          // 未购买商品
          ElMessageBox.confirm(
            userInfo.isAdmin
              ? '请先购买商品-商品电子合同签署后发起'
              : '请联系管理员，购买商品-电子合同签署后发起',
            '提示',
            {
              confirmButtonText: userInfo.isAdmin ? '去购买' : '确定'
            }
          ).then(() => {
            if (userInfo.isAdmin) {
              router.push({
                path: '/appStore',
                query: { goodCode: 'CONTRACT_BUY_SERVICE' }
              })
            }
          })
          reject(res.data)
        } else if (res.data.subCode === 10002) {
          // 剩余次数不足
          ElMessageBox.confirm(
            userInfo.isAdmin
              ? '合同签署已无剩余可用次数，请前往应用商城购买'
              : '合同签署已无剩余可用次数，请联系管理员前往应用商城购买',
            '提示',
            {
              confirmButtonText: userInfo.isAdmin ? '去购买' : '确定'
            }
          ).then(() => {
            if (userInfo.isAdmin) {
              router.push({
                path: '/appStore',
                query: { goodCode: 'CONTRACT_BUY_SERVICE' }
              })
            }
          })
          reject(res.data)
        } else {
          ElNotification.error(res.data.msg)
          reject(res.data)
        }
      }
    } catch (e: any) {
      reject(e)
    }
  })
}

// 撤销合同
export const revokeContract = (data: any) =>
  request.post(perfix + '/retailContractManage/revoke', data, jsonHeaderConfig)

// 删除合同
export const deleteContract = (data: any) =>
  request.post(perfix + '/retailContractManage/delByContractId', data, jsonHeaderConfig)

// 发送前预览
export const preSaveView = (data: any) =>
  request.post(perfix + '/retailContractManage/preSaveView', data, jsonHeaderConfig)

// 发送后预览
export const afterSaveView = (data: any) =>
  request.post(perfix + '/retailContractManage/afterSaveView', data, jsonHeaderConfig)

// 获取机构的实名认证状态
export const getOrgAuth = () => {
  return request.post(perfix + '/retailOrganAuth/checkOrganIsAuth', null, jsonHeaderConfig)
}

// 合同下载打印
export const signFlowFileDownloadUrl = (data: any) =>
  request.post(perfix + '/retailContractManage/signFlowFileDownloadUrl', data, jsonHeaderConfig)

// 合同各状态数量
export const selectStatusCount = () =>
  request.post(perfix + '/retailContractManage/selectStatusCount', null, jsonHeaderConfig)
export const selectStatusCountByPartake = () =>
  request.post(perfix + '/retailContractManage/selectStatusCountByPartake', null, jsonHeaderConfig)

// 获取合同编号
export const buildContractNumber = (data: any) =>
  request.post(perfix + '/retailContractManage/buildContractNumber', data, jsonHeaderConfig)
// 合同作废解约
export const initiateRescission = (data: any) =>
  request.post(perfix + '/retailContractManage/initiateRescission', data, jsonHeaderConfig)

// 作废合同预览
export const previewRescission = (data: any) =>
  request.post(
    perfix + '/retailContractManage/viewInitiateRescissionContract',
    data,
    jsonHeaderConfig
  )

// 下载合同 入参id、contractFunctionType合同功能类型 1.原合同 2.解约合同
export const downloadContractFile = (data: any) =>
  request.post(perfix + '/retailContractManage/downloadContract', data, jsonHeaderConfig)

// 轮询区块链下载结果
export const loopGetContractFile = (data: any): any => {
  return new Promise((resolve, reject) => {
    let timer: any = null
    let times = 0
    timer = setInterval(async () => {
      try {
        const res = await request.post(
          perfix + '/retailContractManage/getDownloadProveResult',
          data,
          jsonHeaderConfig
        )
        times++
        if (res.status === '1') {
          // 成功
          clearInterval(timer)
          resolve(res.downloadUrl)
        }
        if (res.status === '0') {
          // 失败
          clearInterval(timer)
          reject(res.msg || new Error('获取区块链存证下载地址失败，请重试！'))
        }
        // 超过15秒
        if (times > 15) {
          clearInterval(timer)
          reject(res.msg || new Error('获取区块链存证下载地址超时，请重试！'))
        }
      } catch (e) {
        clearInterval(timer)
        reject(e)
      }
    }, 1000)
  })
}

// 合同用——查询paas应用的业务编号
export const getListBusinessData = (data: any) =>
  request.post('/crm/contract/sign/list_business_data', data, jsonHeaderConfig)
